<!--upload:上传答题卡 2024/10/22 09:26:31 Sunanguang-->

<template>
  <div class="third-upload cnt1200">
    <page-header title :paths="['上传答题卡图片']" :use-region-back="false">
      <p @click="downloadExe" class="download">
        下载客户端
        <img src="../../../../../assets/images/download-icon.png" width="16px" alt="下载客户端" />
      </p>
    </page-header>
    <div v-show="fileList.length === 0" class="upload-body">
      <div class="upload-basic">
        <span class="span-label">年级：</span>
        <el-select v-model="upload.grade" @change="loadSubjects()" size="mini" placeholder="选择年级"
          :disabled="optionDisabled">
          <el-option v-for="(grade, index) in gradeList" :key="'grade' + index" :label="grade.gradeName"
            :value="grade.gradeNum"></el-option>
        </el-select>
        <span class="span-label" style="margin-left: 40px">学科：</span>
        <el-select v-model="upload.subjectCode" size="mini" placeholder="选择科目" :disabled="optionDisabled">
          <el-option v-for="(subject, index) in subjectList" :key="'subject' + index" :label="subject.subjectName"
            :value="subject.subjectId"></el-option>
        </el-select>
        <span class="span-label" style="margin-left: 40px">阅卷方式：</span>
        <el-select v-model="upload.isHen" size="mini" placeholder="选择阅卷方式" :disabled="optionDisabled">
          <el-option v-for="(hen, index) in hens" :key="'hen' + index" :label="hen.name" :value="hen.value"></el-option>
        </el-select>
      </div>
      <div class="upload-basic" style="margin-top: 24px;">
        <span class="span-label">张数：</span>
        <el-select v-model="upload.sheetCount" size="mini" placeholder="选择张数" @change="sheetChange"
          :disabled="optionDisabled">
          <el-option v-for="i in 3" :key="'sheetCount' + i" :label="i + '张'" :value="i"></el-option>
        </el-select>
        <span class="span-label" style="margin-left: 40px;">面数：</span>
        <el-radio-group v-model="upload.sideCount" :disabled="optionDisabled">
          <el-radio v-for="side in sides" :key="'side-' + side.value" :label="side.value">{{ side.name }}</el-radio>
        </el-radio-group>
      </div>
      <div class="upload-pic">
        <span class="span-label"></span>
      </div>
      <div class="upload-images">
        <div v-if="fileList.length > 0" class="upload-image">
          <el-image :src="upload.ossUrl" :preview-src-list="fileList" fit="scale-down"
            style="width:100%;height:100%"></el-image>
          <span class="el-icon-circle-close" @click="fileList = []"></span>
        </div>
      </div>
      <!--上传方式-->
      <div class="upload-ways">
        <!-- 如果是灰度，才显示客户端连接操作 -->
        <div v-if="isGrayscaleUser" class="upload-way upload-client">
          <div class="upload-logo" @click="startScanAction">
            <div class="inner-logo">
              <img alt="添加图片" src="../../assets/images/scan-img.png" />
              <p>扫描答题卡</p>
            </div>
          </div>
          <div class="upload-desc">
            <span style="color: #333;">客户端：</span>
            <span v-if="connectStatus > 0" style="color:#2877FF">已连接</span>
            <template v-else>
              <span style="color:#FF4C3B">未连接</span>
              <el-popover placement="right" width="320" trigger="click">
                <div style="line-height:1.5;font-size: 12px">
                  <p><span style="font-weight: bold">未连接，请按以下步骤检查：</span></p>
                  <p>1、是否安装扫描仪驱动；</p>
                  <p>2、usb是否连接正常</p>
                </div>
                <span slot="reference" class="el-icon-question"></span>
              </el-popover>
            </template>
            <i class="upload-client-sitting" @click="openScanCoinfg" title="设置扫描参数"></i>
          </div>
        </div>
        <div class="upload-way">
          <el-upload ref="upload" style="color: #2877ff" type="info" accept=".png, .jpg, .jpeg" multiple action
            :on-change="handleChangeAction" :file-list="fileList" :show-file-list="false" :auto-upload="false">
            <div class="upload-logo">
              <div class="inner-logo">
                <img alt="添加图片" src="../../assets/images/upload-img.png" />
                <p>上传图片</p>
              </div>
            </div>
          </el-upload>
          <div class="upload-desc">支持 jpg、png格式，小于5M</div>
          <div v-if="uploadDisabled" class="upload-cover" @click="startScanAction"></div>
        </div>
      </div>
      <div class="upload-footer">
        <el-button class="ok-btn" style="float: left;" size="small" @click="createCard()">确定</el-button>
      </div>
    </div>
    <!--上传或扫描图片后-->
    <div v-show="fileList.length > 0" class="upload-files-result upload-body">
      <div class="upload-basic">
        <span class="span-label" style="width: 85px;">答题卡规格：</span><span style="font-size: 14px;">{{ upload.sheetCount
          }}张{{
            upload.sideCount }}面</span>
      </div>
      <div class="upload-basic-item" style="margin-top: 20px;">
        <span class="span-label" style="width: 85px;vertical-align: top;">答题卡预览：</span>
        <div class="upload-image-list">
          <draggable class="bk-drag-inner-container" tag="div" v-model="fileList" ghostClass='bk-drag-ghost'
            :delay='100' chosenClass='bk-drag-chosen' dragClass='bk-drag-drag' :animation='0'
            :disabled="fileList.length <= 1" :move="moveEvent" filter=".marking-disabled,.marking-op">
            <transition-group type="transition" name="bk-question-drag">
              <div v-for="i in upload.sideCount" :key="'image-' + i" class="upload-image-item"
                :class="{ 'marking-disabled': i > fileList.length }">
                <template v-if="i <= fileList.length">
                  <el-image ref="images" :src="fileList[i - 1]" :preview-src-list="fileList" fit="scale-down"
                    style="width:100%;height:100%"></el-image>
                  <span v-if="fileList.length > 1" class="marking-drag-desc">拖拽图片调整顺序</span>
                  <span @click="previewAction(i)" class="el-icon-search marking-op"></span>
                  <span @click="transformAction(i)" class="marking-icon-transform marking-op"></span>
                </template>
                <span v-else class="marking-desc">答题卡不全，请继续{{ uploadType === 'scan' ? '扫描' : '上传' }}！</span>
                <span class="el-icon-circle-close" @click="fileList = []"></span>
                <p class="marking-item-desc">第{{ Math.ceil(i / 2) }}张{{ (i - 1) % 2 === 0 ? '正' : '反' }}面</p>
              </div>
            </transition-group>
          </draggable>
        </div>
      </div>
      <div class="upload-footer">
        <el-button type="primary" plain class="btn-size" size="mini" style="float: left;"
          @click="clearFiles">清空图片</el-button>
        <el-button type="primary" plain class="btn-size" size="mini" style="float: left;"
          @click="continueScan">{{ !isCanCut
            ? '继续' : '重新'}}{{ uploadType === 'scan' ? '扫描' : '上传' }}</el-button>
        <el-button type="primary" class="btn-size" size="mini" :disabled="!isCanCut" style="float: left;"
          @click="createCard((data) => { showCut(data) })">切题</el-button>
        <el-button class="btn-size" type="primary" plain size="mini" @click="createCard()"
          :disabled="!isCanCut || !!upload.examIdForTemplate" style="float: left;">保存</el-button>
      </div>
      <div class="upload-warning">
        <p>1、请确保顺序正确</p>
        <p>2、如答题卡倒立，可以进行旋转</p>
        <p>3、如扫描异常，可以重新扫描</p>
      </div>
    </div>

    <yue-dialog title="切题设置" :visible.sync="dialog.visible" width="400px" top="calc(50vh - 130px)">
      <dialog-body :item="dialog"> </dialog-body>
    </yue-dialog>
    <client-scan ref="clientScan" class="marking-scan" :exam="examDemo" @change="changeAction"
      type="scan-card-template"></client-scan>
    <div v-if="uploading" class="uploading-mask">
      <div class="uploading-content">
        <span class="yj-icon-loading uploading-icon"></span>
        上传中，请勿操作（{{ uploadedCount }}<span v-if="uploadType === 'upload'">/{{ uploadFileCount }}</span>）...
      </div>
    </div>
  </div>
</template>
<script>
import PageHeader from '../../../../../v2/views/components/PageHeader'
import { baseApi } from '@/v2/utils/api'
import { cardApi } from '@/v3/modules/card/utils/api'
import AliOSS from 'ali-oss'
import { mapGetters } from 'vuex'
import { cardData } from '@/v2/utils/data'
import ClientScan from '@/v3/modules/card_use/views/student-answer/components/ClientScan'
import util from '@/v2/utils/util'
import DialogBody from '@/v3/modules/exam/components/DialogBody.vue'
import draggable from 'vuedraggable'

export default {
  components: { PageHeader, DialogBody, ClientScan, draggable },
  name: 'upload',
  data () {
    return {
      examDemo: {
        examCode: 'examCode',
        examName: 'examName'
      },
      subjectList: [],
      upload: {
        subjectCode: '',
        grade: '',
        ossUrl: '',
        isHen: 'NON_WRITING',
        sheetCount: 1, // 张数
        sideCount: 1 // 面数
      },
      hens: cardData.getHens(),
      dialog: {
        key: 'cutTip',
        visible: false,
        data: null,
        name: '',
        type: ''
      },
      sides: [
        {
          name: '1面',
          value: 1
        },
        {
          name: '2面',
          value: 2
        }
      ],
      fileList: [], // 已上传文件列表
      connectStatus: -1, // 客户端连接状态
      uploading: false, // 是否正在上传
      uploadType: 'upload', // 上传类型
      uploadFileCount: 0, // 上传文件数量
      uploadedCount: 0 // 已上传文件数量
    }
  },
  computed: {
    ...mapGetters({
      userInfo: "getUserInfo",
      gradeList: 'getGradeList',
      isGrayscaleUser: 'isGrayscaleUser'
    }),
    isCanCut () {
      // 是否能切题（上传图片数量达到规格要求数量）
      return this.fileList.length >= this.upload.sideCount
    },
    uploadDisabled () {
      const { grade, subjectCode, isHen } = this.upload
      return !grade || !subjectCode || !isHen
    },
    optionDisabled () {
      return !!this.upload.examIdForTemplate
    }
  },
  async created () {
    this.upload.examIdForTemplate = this.$route.query.examIdForTemplate
    this.examDemo.examName = '第三方卡模板'
    this.examDemo.examCode = 'userId_' + this.userInfo.userId + '_' + this.generateRandomId()
    baseApi.getSTSToken().then(opt => {
      this.ossClient = new AliOSS(opt)
    })
    await this.getMainTemplate()
  },
  methods: {
    async getMainTemplate () {
      // 获取主模版
      if (this.upload.examIdForTemplate) {
        const res = await cardApi.getMainTemplate(this.upload.examIdForTemplate)
        if (res.success) {
          const body = res.body
          this.upload.subjectCode = body.subjectCode
          this.upload.grade = body.grade
          this.upload.isHen = body.isHen
          this.upload.sideCount = body.sideCount
          this.upload.sheetCount = body.sheetCount
          this.loadSubjects()
          this.getSheetDatas()
        }
      }
    },
    downloadExe () {
      if (this.isGrayscaleUser) {
        this.$root.$children[0].downloadExe()
      } else {
        util.download('https://official.zxxk.com/client/RCEInstall.zip')
      }
    },
    loadSubjects () {
      if (!this.upload.examIdForTemplate) {
        this.upload.subjectCode = ''
      }
      if (!this.upload.grade) {
        this.subjectList = []
        return
      }
      baseApi.getGradeSubjects({
        grade: this.upload.grade,
        schoolId: this.userInfo.schoolId,
      }).then(resp => {
        if (resp.body) {
          this.subjectList = resp.body
        } else {
          this.subjectList = []
        }
      })
    },
    checkSetting (ignoreImg) {
      // 检查设置
      const { grade, subjectCode, isHen } = this.upload
      let checked = true
      if (!grade) {
        checked = false
        this.$message.warning('未设置年级')
      } else if (!subjectCode) {
        checked = false
        this.$message.warning('未设置学科')
      } else if (!isHen) {
        checked = false
        this.$message.warning('未设置阅卷方式')
      }
      if (!ignoreImg) {
        if (this.fileList.length === 0) {
          checked = false
          this.$message.warning('未上传图片')
        }
      }
      return checked
    },
    async createCard (callback) {
      // 保存制卡
      if (!this.checkSetting(false)) {
        return
      }
      const { grade, subjectCode, isHen } = this.upload

      let gradeInfo = this.gradeList.find(item => item.gradeNum === grade)
      let subjectInfo = this.subjectList.find(item => item.subjectId === subjectCode)
      const params = {
        subjectName: subjectInfo.subjectName,
        gradeName: gradeInfo.gradeName,
        schoolId: this.userInfo.schoolId,
        grade: grade,
        subjectCode: subjectCode,
        isHen: isHen,
        sheetCount: this.upload.sheetCount,
        sideCount: this.upload.sideCount,
        images: []
      }
      for (let i = 0; i < this.upload.sideCount; i++) {
        const sheetNum = Math.ceil((i + 1) / 2)
        const sideNum = i % 2 + 1
        params.images.push({
          sheetNum: sheetNum,
          sideNum: sideNum,
          imageUrl: this.fileList[i]
        })
      }
      const resp = await cardApi.uploadCardImg(params)
      if (resp.body) {
        resp.body.gradeName = gradeInfo.gradeName
        resp.body.subjectName = subjectInfo.subjectName
        if (callback) {
          const date = new Date()
          const year = date.getFullYear()
          const name = params.gradeName + params.subjectName + year.toString().slice(-2) + util.generateDateTimeString()
          const imgKey = 'images_' + resp.body.id
          const router = {
            path: '/v2/card/third-multiple/cut',
            query: {
              name,
              type: isHen,
              grade: params.grade,
              subjectCode: params.subjectCode,
              sheetCount: params.sheetCount,
              sideCount: params.sideCount,
              imgKey: imgKey,
              examIdForTemplate: this.upload.examIdForTemplate
            }
          }
          sessionStorage.setItem(imgKey, JSON.stringify(this.fileList))
          this.$router.push(router)
        } else {
          this.$router.back()
        }
      } else {
        this.$message.error(resp.message || '上传失败')
      }
    },
    showCut (data) {
      this.dialog.data = data
      this.dialog.source = 'upload'
      this.dialog.name = data.gradeName + data.subjectName + util.generateDateTimeString()
      this.dialog.visible = true
    },
    generateRandomId () {
      return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
    },
    sheetChange () {
      // 张数变化
      this.getSheetDatas()
      this.upload.sideCount = this.sides[0].value
    },
    getSheetDatas () {
      // 获取答题卡数据
      this.sides = []
      // 一张纸最多两面
      for (let index = 1; index <= 2; index++) {
        const count = 2 * (this.upload.sheetCount - 1) + index
        this.sides.push({
          name: count + '面',
          value: count
        })
      }
    },
    clearFiles () {
      // 清空图片
      this.fileList = []
    },
    startScanAction () {
      // 开始扫描
      if (!this.checkSetting(true)) {
        return
      }
      // 开始扫描
      this.uploading = true
      this.uploadType = 'scan'
      this.uploadedCount = 0
      this.$refs.clientScan.startScan()
    },
    continueScan () {
      // 继续扫描、重新扫描
      if (this.isCanCut) {
        // 重新扫描
        this.fileList = []
      }
      if (this.uploadType === 'scan') {
        this.startScanAction()
      } else {
        // 继续上传
        this.$refs.upload.$el.querySelector('.el-upload__input').click()
      }
    },
    handleChangeAction (file, fileList) {
      // 文件上传逻辑处理
      if (!this.checkSetting(true)) {
        return
      }
      // 过滤掉已上传的文件
      fileList = fileList.filter(item => item.status === 'ready' && !item.ossUrl)
      this.uploadedCount = 0
      this.uploadFileCount = fileList.length
      this.uploadType = 'upload'
      this.uploading = true
      this.$refs.clientScan.handleChange(file, fileList)
    },
    openScanCoinfg () {
      // 打开配置文件
      this.$refs.clientScan.openScanConfig()
    },
    changeAction (data) {
      // 监听状态变化
      const code = data.code
      const body = data.body
      if (code === 200) {
        const command = body.command
        switch (command) {
          case 'connect-status':
            // 连接状态
            this.connectStatus = body.status
            break
          case 'report-scan-progress':
            // 扫描进度
            // this.uploading = true
            // this.uploadType = 'scan'
            // this.uploadFileCount = body.data.count
            break
          case 'local-upload-progress':
          case 'report-upload-progress':
            const url = body.ossUrl
            this.fileList.push(url)
            this.uploadedCount++
            break
          case 'report-sammary-info':
          case 'local-sammary-info':
            // 扫描结束
            this.uploading = false
            break
        }
      }
    },
    previewAction (index) {
      const refs = this.$refs.images
      if (refs && refs.length > 0) {
        refs[0].src = this.fileList[index - 1]
        // 如果需要设置起始预览图片
        this.$nextTick(() => {
          refs[0].showViewer = true
        })
      }
    },
    transformAction (index) {
      // 旋转图片
      const img = this.fileList[index - 1]
      const imgArr = img.split('?x-oss-process=image')
      const rotate = (imgArr[1] ? parseInt(imgArr[1].replace('/rotate,', ''), 10) : 0) + 90
      const newImg = this.getNewOssUrl(imgArr[0], rotate)
      this.fileList[index - 1] = newImg
      this.$forceUpdate()
    },
    getNewOssUrl (url, rotate = 0, crop = '') {
      const list = []
      list.push(`/rotate,${rotate}`)
      if (crop) {
        list.push(crop)
      }
      const prefix = '?x-oss-process=image'
      if (url.indexOf(prefix) >= 0) {
        return `${url},${list.join(',')}`
      } else {
        return `${url}${prefix}${list.join(',')}`
      }
    },
    moveEvent (evt) {
      // 无图片的禁止拖拽
      if (evt.related.classList.contains('marking-disabled')) {
        return false
      }
      return true
    }
  },
  filters: {
    transformToChinese (num) {
      return util.transformToChinese(num);
    }
  }
}
</script>

<style scoped>
.third-upload {
  margin-bottom: 16px;
}

.third-upload ::v-deep .page-header {
  border-bottom: none;
}

.download {
  display: flex;
  align-items: center;
  color: #2877ff;
  text-align: center;
  font-family: "PingFang SC";
  font-style: normal;
  font-weight: 400;
  line-height: 14px;
  justify-content: right;
  font-size: 14px;
  cursor: pointer;
}

.download>img {
  margin-left: 5px;
  width: 16px;
}

.upload-body {
  padding: 24px 32px;
  background: white;
  margin-top: 16px;
  min-height: calc(100vh - 274px);
}

.upload-basic {
  display: flex;
  align-items: center;
}

.upload-basic ::v-deep input {
  font-size: 14px;
  padding-left: 8px;
}

.upload-basic ::v-deep input::placeholder {
  color: #999;
}

.span-label {
  display: inline-block;
  width: 75px;
  font-size: 14px;
}

.upload-pic {
  display: flex;
  align-items: center;
  margin-top: 12px;
}

.upload-images {
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 10px;
}

.upload-image {
  width: 566px;
  height: 357px;
  background: #f0f0f0;
  margin-left: 76px;
  margin-top: 10px;
  position: relative;
  border-radius: 4px;
}

.upload-image .add {
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  width: 566px;
  height: 357px;
}

.el-icon-circle-close {
  position: absolute;
  top: -9px;
  right: -9px;
  font-size: 18px;
  display: none;
}

.upload-image:hover .el-icon-circle-close {
  display: block;
}

.upload-footer {
  font-size: 12px;
  color: #666666;
  padding-left: 74px;
  height: 100px;
  padding-left: 290px;
}

.upload-footer ::v-deep .el-button {
  padding: 8px 36px;
  float: right;
  margin-top: 30px;
  margin-left: 20px;
}

.upload-ways {
  margin-top: 2px;
}

.upload-ways::after,
.upload-image-list::after {
  clear: both;
  content: '';
  display: block;
}

.upload-way {
  width: 220px;
  height: 300px;
  float: left;
  position: relative;
}

.upload-way .upload-logo {
  width: 226px;
  height: 226px;
  border: 1px solid #DDDDDD;
  text-align: center;
  cursor: pointer;
  border-radius: 4px;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  align-items: center;
}

.upload-way .upload-logo:hover,
.upload-cover:hover {
  border: 2px solid #2877FF;
}

.upload-way .upload-logo p {
  font-size: 14px;
  color: #999999;
}

.upload-way .upload-logo img {
  margin-bottom: 8px;
}

.upload-way .upload-desc {
  font-size: 14px;
  color: #666666;
  margin-top: 18px;
}

.upload-client .upload-desc {
  color: #333333;
}

.upload-client {
  margin-right: 50px;
  margin-left: 75px;
}

.upload-client-sitting {
  float: right;
  width: 16px;
  height: 16px;
  cursor: pointer;
  background: url('../../assets/images/setting-logo.png');
}

.upload-image-item {
  width: 180px;
  height: 120px;
  margin-right: 20px;
}

.upload-image-list {
  display: inline-block;
  width: calc(100% - 94px);
}

.upload-image-list .upload-image-item {
  float: left;
  width: 226px;
  height: 226px;
  position: relative;
  margin-right: 32px;
  background: #F0F0F0;
  margin-bottom: 58px;
}

.upload-image-list .upload-image-item .marking-desc {
  display: block;
  width: 100%;
  height: 226px;
  text-align: center;
  line-height: 226px;
  font-size: 14px;
  color: #666666;
}

.upload-warning {
  margin-top: 20px;
  padding-left: 90px;
}

.upload-warning p {
  line-height: 1.5;
  font-size: 14px;
  color: #666666;
}

.marking-scan {
  width: 0;
  height: 0;
  overflow: hidden;
}

.upload-cover {
  position: absolute;
  top: 0;
  left: 0;
  width: 226px;
  height: 226px;
  z-index: 10;
  cursor: pointer;
  box-sizing: border-box;
  border: 1px solid #DDDDDD;
  border-radius: 4px;
}

.ok-btn {
  width: 100px;
  border: 1px solid #2877FF;
  color: #2877FF;
}

.btn-size {
  width: 100px;
  padding: 8px 0px !important;
  text-align: center;
}

.uploading-mask {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  z-index: 1000;
}

.uploading-content {
  width: 400px;
  height: 56px;
  line-height: 56px;
  background: #E6F2FF;
  border-radius: 4px;
  font-size: 14px;
  color: #1A1A1A;
  position: absolute;
  top: calc(50vh - 28px);
  left: calc(50vw - 200px);
  padding-left: 24px;
}

.uploading-icon {
  float: left;
  margin-top: 17px;
}

@keyframes load {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

.marking-item-desc {
  text-align: center;
  margin-top: 18px;
  font-size: 14px;
  color: #666666;
}

.marking-drag-desc {
  font-size: 14px;
  color: white;
  width: 100%;
  text-align: center;
  height: 30px;
  line-height: 30px;
  background: rgba(51, 51, 51, 0.5);
  position: absolute;
  top: 0;
  left: 0;
}

.upload-image-item .marking-op {
  color: white;
  background: rgba(51, 51, 51, 0.5);
  position: absolute;
  right: 0px;
  bottom: 0px;
  cursor: pointer;
  padding: 7px 9px;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
  border-bottom-left-radius: 4px;
  font-size: 12px;
}

.upload-image-item .el-icon-search {
  right: 38px;
  border-radius: 4px;
}

.upload-image-item .marking-icon-transform {
  background-image: url('../../../../../assets/images/transform.png');
  background-position: center center;
  background-repeat: no-repeat;
  background-size: 12px 12px;
  padding: 0;
  width: 30px;
  height: 26px;
}

.upload-image-item .marking-op:hover {
  background-color: #005eff;
}
</style>
